"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.CaseHold = exports.HoldReasonLabel = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
// React imports
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var ui_common_1 = require("@codametrix/ui-common");
var HoldReasonType = ui_common_1.commonEnums.HoldReasonType;
var HoldReasonLabel;
(function (HoldReasonLabel) {
    HoldReasonLabel["HOLD"] = "Hold";
    HoldReasonLabel["HOLD_FOR_DOCUMENTATION_QUERY"] = "Hold for documentation query";
    HoldReasonLabel["HOLD_FOR_MANAGER_REVIEW"] = "Hold for manager review";
    HoldReasonLabel["OFF_HOLD"] = "Off hold";
})(HoldReasonLabel = exports.HoldReasonLabel || (exports.HoldReasonLabel = {}));
var CaseHold = /** @class */ (function (_super) {
    __extends(CaseHold, _super);
    /**
     * Constructor method for class CaseHold
     * @param {Accelerate.CaseHoldProps} props - Props object passed to CaseHold component
     */
    function CaseHold(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            comment: '',
            holdReason: HoldReasonType.HOLD
        };
        _this.handleOptionChange = _this.handleOptionChange.bind(_this);
        _this.handleCommentChange = _this.handleCommentChange.bind(_this);
        _this.holdCase = _this.holdCase.bind(_this);
        _this.cancelHold = _this.cancelHold.bind(_this);
        return _this;
    }
    /**
     * Method to handle the change event for radio button options
     * @param {Object} event - Event object
     */
    CaseHold.prototype.handleOptionChange = function (event) {
        this.setState({ holdReason: event.target.id });
    };
    /**
     * Method to handle the change event for text area element
     * @param {Object} event - Event object
     */
    CaseHold.prototype.handleCommentChange = function (event) {
        this.setState({ comment: event.target.value });
    };
    /**
     * Method to hold the case
     */
    CaseHold.prototype.holdCase = function () {
        this.props.onHold(this.state.holdReason, this.state.comment);
    };
    /**
     * Method to cancel holding the case
     */
    CaseHold.prototype.cancelHold = function () {
        this.props.onCancel();
    };
    CaseHold.prototype.render = function () {
        return ((0, jsx_runtime_1.jsxs)("form", __assign({ className: "case-hold", onSubmit: function (e) { return e.preventDefault(); } }, { children: [(0, jsx_runtime_1.jsx)("p", __assign({ className: "case-hold-subtitle" }, { children: "The case will be put on hold for 3 days." })), (0, jsx_runtime_1.jsxs)("div", __assign({ className: "case-hold-group" }, { children: [(0, jsx_runtime_1.jsxs)("div", __assign({ className: "case-hold-radio-group" }, { children: [(0, jsx_runtime_1.jsx)("input", { type: "radio", name: "holdReason", id: HoldReasonType.HOLD, className: "case-hold-radio-input", onChange: this.handleOptionChange, checked: this.state.holdReason === HoldReasonType.HOLD }), (0, jsx_runtime_1.jsxs)("label", __assign({ className: "case-hold-label-radio case-hold-radio-label", htmlFor: HoldReasonType.HOLD }, { children: [(0, jsx_runtime_1.jsx)("span", { className: "case-hold-radio-button" }), HoldReasonLabel.HOLD] }))] })), (0, jsx_runtime_1.jsxs)("div", __assign({ className: "case-hold-radio-group" }, { children: [(0, jsx_runtime_1.jsx)("input", { type: "radio", name: "holdReason", id: HoldReasonType.HOLD_FOR_DOCUMENTATION_QUERY, className: "case-hold-radio-input", onChange: this.handleOptionChange, checked: this.state.holdReason ===
                                        HoldReasonType.HOLD_FOR_DOCUMENTATION_QUERY }), (0, jsx_runtime_1.jsxs)("label", __assign({ className: "case-hold-label-radio case-hold-radio-label", htmlFor: HoldReasonType.HOLD_FOR_DOCUMENTATION_QUERY }, { children: [(0, jsx_runtime_1.jsx)("span", { className: "case-hold-radio-button" }), HoldReasonLabel.HOLD_FOR_DOCUMENTATION_QUERY] }))] })), (0, jsx_runtime_1.jsxs)("div", __assign({ className: "case-hold-radio-group" }, { children: [(0, jsx_runtime_1.jsx)("input", { type: "radio", name: "holdReason", id: HoldReasonType.HOLD_FOR_MANAGER_REVIEW, className: "case-hold-radio-input", onChange: this.handleOptionChange, checked: this.state.holdReason === HoldReasonType.HOLD_FOR_MANAGER_REVIEW }), (0, jsx_runtime_1.jsxs)("label", __assign({ className: "case-hold-label-radio case-hold-radio-label", htmlFor: HoldReasonType.HOLD_FOR_MANAGER_REVIEW }, { children: [(0, jsx_runtime_1.jsx)("span", { className: "case-hold-radio-button" }), HoldReasonLabel.HOLD_FOR_MANAGER_REVIEW] }))] }))] })), (0, jsx_runtime_1.jsx)("textarea", { className: "case-hold-comment form-input input", placeholder: "Enter comments (optional)", maxLength: 1024, onChange: this.handleCommentChange, rows: 4 }), (0, jsx_runtime_1.jsxs)("div", __assign({ className: "case-hold-buttons-group" }, { children: [(0, jsx_runtime_1.jsx)("button", __assign({ onClick: this.cancelHold, className: "chakra-secondary-button" }, { children: "Cancel" })), (0, jsx_runtime_1.jsx)("button", __assign({ onClick: this.holdCase, className: (0, classnames_1["default"])('chakra-primary-button') }, { children: "Hold" }))] }))] })));
    };
    CaseHold.displayName = 'CaseHold';
    return CaseHold;
}(react_1["default"].Component));
exports.CaseHold = CaseHold;
//# sourceMappingURL=case-hold.js.map